module.exports = __webpack_public_path__ + "static/media/icon-apartment-main.6df5ad67.svg";